import { render, staticRenderFns } from "./Bootstrap.vue?vue&type=template&id=2962e24a"
import script from "./Bootstrap.vue?vue&type=script&lang=js"
export * from "./Bootstrap.vue?vue&type=script&lang=js"
import style0 from "./Bootstrap.vue?vue&type=style&index=0&id=2962e24a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports